import { accessToken } from "@/util/storageHelper";
import { BeforeRequestHook } from "ky";

export const injectToken: BeforeRequestHook = (request) => {
  const token = accessToken.get();

  if (token) request.headers.set("authorization", "Bearer " + token);
};
